import {WallPiece} from 'src/common/map/WallPiece';
import {Location} from 'src/common/map/Location';
import {Game} from '../Game';
import Connection from 'src/Connection';
import {wallRenderer} from 'src/Pixi/map/WallRenderer';
import {BuildWallAction} from 'src/Action';
import {heldRenderer} from 'src/Pixi/map/HeldRenderer';
import {spawnRenderer} from 'src/Pixi/map/SpawnRenderer';

export class BuildWall {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer(action: BuildWallAction): void {
        const loc = new Location(action.x, action.y);
        const piece = new WallPiece(action.tiles, action.rotation);
        this.game.map.placeWallPiece(
            action.index,
            action.x,
            action.y,
            action.rotation,
            action.tiles
        );
        heldRenderer.redraw();
        wallRenderer.buildWallPiece(piece.rotatedLocations(loc));
        spawnRenderer.redraw(this.game.map);
        this.game.players[action.index].wallPiece = action.next;
    }

    public byClient(loc: Location, piece: WallPiece): void {
        Connection.send('build', {x: loc.x, y: loc.y, rotation: piece.rotation});
        this.game.map.placeWallPiece(this.game.index, loc.x, loc.y, piece.rotation, piece.tiles);
        heldRenderer.redraw();
        wallRenderer.buildWallPiece(piece.rotatedLocations(loc));
        spawnRenderer.redraw(this.game.map);
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/BuildWall.ts